import './less/spinner.less';

class Spinner{
    
    constructor(){
      this.classes = {
          'main' : 'spinner' // main spinner element class
      };
    }

    buildSpinner = (parent, color, icon = '<i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>')  => {
        let container = document.createElement('div');
        container.className = this.classes.main;
        container.style.backgroundColor = color;
        container.style.opacity = 0.6;
        //container.innerHTML = icon;
        
        parent.append(container);
    };
    
    show = (parent, color) => {
        this.buildSpinner(parent, color);
    }
    
    remove = () => {
        $('.spinner').remove();
    }
    
}

const spinner = new Spinner();

export { spinner };


// WEBPACK FOOTER //
// ./components/spinner/spinner.js